import { ASSIGNABLE_ROLES, IRoleOption } from '@/models/admins.model';
import { TFunction } from 'react-i18next';

// Role options come from the 12-role catalog; labels are localized from the
// `common:roles.*` namespace.
export const getRoleOptions = (t: TFunction): IRoleOption[] =>
  ASSIGNABLE_ROLES.map((value) => ({ value, label: t(`common:roles.${value}`) }));

export const getStatusOptions = (t: TFunction) => {
  return [
    {
      value: '1',
      label: t('users_list_active_badge'),
    },
    {
      value: '0',
      label: t('users_list_inactive_badge'),
    },
  ];
};
